import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';

import { Attendance } from '../../../../models/attendance';
import { getUser } from '../../../../service/user';

import UserImage from '../../../../components/UserImage/UserImage';

import styles from './AttendanceItem.module.scss';
import Icon from '../../../../components/Icon/Icon';
import { main_color } from '../../../../styles/_variables';

interface PropsAttendanceSumary {
  attendance: Attendance
}

type Props = Pick< PropsAttendanceSumary, 'attendance'> ;

const AttendanceItem = ({ attendance }: Props) => {

  const navigate = useNavigate();
  const meetId = attendance.meetId;
  const userId = attendance.userId;

  const {data:user, isFetching: isFetchingMeet} = useQuery(
    ['user', userId],
    () => getUser(userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const isFetching = isFetchingMeet;

  if (isFetching) return null;

  return (
    <div className={styles.item} key={"attendance_"+meetId}>
      <div className={styles.userContainer} onClick={() => navigate(`/user/${user.id}`)}>
          <UserImage style={styles.circleUser} path={user?.pathPhoto} name={user?.fullname}/>
          <span>{user?.fullname}</span>
      </div>
      <div className={styles.icon}>
        {attendance.wasInAttendance 
          ? <span title="Presente"><Icon color={main_color} icon="check" /></span>
          : <span title="Ausente"><Icon color={main_color} icon="uncheck" /></span>
        } 
      </div>
    </div>
  )
}

export default AttendanceItem;